import type { PredictionMarketSection, PredictionMarketTypeName } from '@/services/prediction/types'

/**
 * Port of cdc-web `src/components/knockOuts/helpers/findFullPeriodSection.ts`（1:1）。
 *
 * Find the full-game section for a given market type.
 * - When `period` data is present (BE has configured periods), returns the `period === 'full'` section.
 * - When no `period` data is present (legacy events), returns the first matching section.
 */
export function findFullPeriodSection(
  sections: PredictionMarketSection[],
  marketTypeName: PredictionMarketTypeName,
): PredictionMarketSection | undefined {
  const matched = sections.filter(s => s.market_type_name === marketTypeName)
  const hasPeriod = matched.some(s => s.period === 'full' || s.period === 'first_half')
  return hasPeriod ? matched.find(s => s.period === 'full') : matched[0]
}
